import React, { useState } from "react";
import RootLayout from "./root-layout";
import MainImage from "./MainImage";
import { Link, useNavigate, useParams } from "react-router-dom";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { BiLock } from "react-icons/bi";

import axiosInstance from "../../apiInstances/axiosInstance";
import { toast } from "react-toastify";

const ResetPassword = () => {
  const navigate = useNavigate();
  const { link } = useParams();

  const [data, setData] = useState({
    password: "",
    conformpassword: "",
  });

  const chnages = (event) => {
    const { name, value } = event.target;
    setData((data) => {
      return { ...data, [name]: value };
    });
  };

  const mydata = {
    password: data?.password,
    conformpassword: data?.conformpassword,
    link: link,
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    await axiosInstance
      .post(`reset_password/${link}`, mydata)
      .then((res) => {
        console.log("reset_password----------->", res.data.status);
        res.data.status === true ? navigate(`/signin`) : toast.error(res.data.message);
      })
      .catch((err) => console.log(err));
  };

  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  function togglePasswordVisibility() {
    setIsPasswordVisible((prevState) => !prevState);
  }
  return (
    <>
      <RootLayout>
        <MainImage className="mt-8" />

        <div className="bg-white w-full max-w-xl rounded-3xl md:mt-16 mt-5 md:p-16 p-5 flex-center flex-col mb-4">
          <h1 className="text-regal-blue font-josefin font-bold  text-4xl mt-5 text-center text-[#294894]">
            Reset Password
          </h1>
          <div className="md:mt-12 mt-8">
            <div>
              <div className="relative mb-6 border w-full rounded-lg">
                <div className="flex items-center text-[#A9A9A9]">
                  <span>
                    <BiLock size={25} className=" ml-2" />
                  </span>
                  <input
                    type={isPasswordVisible ? "text" : "password"}
                    id="input-group-2"
                    className="form-input-filed font-medium font-sans outline-none w-full py-2 px-2 rounded-lg"
                    placeholder="New password"
                    name="password"
                    value={data.password}
                    onChange={chnages}
                  />
                </div>
                <button
                  className="absolute inset-y-0 right-0 flex items-center px-4 text-[#A9A9A9]"
                  onClick={togglePasswordVisibility}
                >
                  {isPasswordVisible ? (
                    <AiOutlineEye />
                  ) : (
                    <AiOutlineEyeInvisible />
                  )}
                </button>
              </div>
            </div>

            <div>
              <div className="relative mb-6 border w-full rounded-lg">
                <div className="flex items-center text-[#A9A9A9]">
                  <span>
                    <BiLock size={25} className=" ml-2" />
                  </span>
                  <input
                    type={isPasswordVisible ? "text" : "password"}
                    id="input-group-2"
                    className="form-input-filed font-medium font-sans outline-none w-full py-2 px-2 rounded-lg"
                    placeholder="Confirm new password"
                    name="conformpassword"
                    value={data.conformpassword}
                    onChange={chnages}
                  />
                </div>
                <button
                  className="absolute inset-y-0 right-0 flex items-center px-4 text-[#A9A9A9]"
                  onClick={togglePasswordVisibility}
                >
                  {isPasswordVisible ? (
                    <AiOutlineEye />
                  ) : (
                    <AiOutlineEyeInvisible />
                  )}
                </button>
              </div>
            </div>

            <div className="justify-center items-center flex">
              <button
                onClick={handleSubmit}
                className="bg-[#22345C] rounded-lg py-3 mt-8 px-8 font-medium text-lg text-white leading-normal "
              >
                Reset
              </button>
            </div>
          </div>
        </div>
      </RootLayout>
    </>
  );
};

export default ResetPassword;
